var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;var _extends2=_interopRequireDefault(require("@babel/runtime/helpers/extends"));var _react=_interopRequireDefault(require("react"));
require("@adyen/adyen-web/dist/adyen.css");
require("react-loading-skeleton/dist/skeleton.css");var _this=this,_jsxFileName="/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/src/whitelabel/pages/_app.js";


var flavour=
process.env._24I_APP_BUILD_ID==='appstage'||!process.env._24I_APP_BUILD_ID?
'experience':
process.env._24I_APP_BUILD_ID;



var App=require("../../"+flavour+"/app.web").default;

var WebApp=function WebApp(props){return _react.default.createElement(App,(0,_extends2.default)({},props,{__self:_this,__self:_this,__source:{fileName:_jsxFileName,lineNumber:15,columnNumber:27}}));};var _default=

WebApp;exports.default=_default;